import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  DxButtonModule,
  DxCheckBoxModule,
  DxFileUploaderModule,
  DxFormModule,
  DxPopupModule,
} from 'devextreme-angular';
import { PasswordUpdateModule } from 'src/app/shared/components/password-update/password-update.component';
import {
  PersonalInfoModule,
} from 'src/app/shared/components/personal-info/personal-info.component';
import { SubscribeEmailsModule } from 'src/app/shared/components/subscribe-emails/subscribe-emails.component';
import { UserPictureModule } from 'src/app/shared/components/user-picture/user-picture.component';
import { UserPicturePreviewModule } from '../user-picture-preview/user-picture-preview.module';
import { UserProfileRoutesModule } from './user-profile.routs.module';
import { UserProfileComponent } from './user-profile.component';

@NgModule({
  imports: [
    CommonModule,
    DxPopupModule,
    UserPicturePreviewModule,
    DxFileUploaderModule,
    DxButtonModule,
    DxFormModule,
    DxCheckBoxModule,
    PasswordUpdateModule,
    PersonalInfoModule,
    SubscribeEmailsModule,
    UserPictureModule,
    UserProfileRoutesModule,
  ],

  declarations: [UserProfileComponent],
  exports: [UserProfileComponent],
})
export class UserProfileModule {}
